import { Link } from 'react-router-dom';
import { latestManga } from '@/mocks/manga';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">每周五更新，精彩不错过</p>
          </div>
          <Link
            to="/category/ke-huan-qi-huan"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            更多新作 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {latestManga.slice(0, 4).map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.slug}`}
              className="group flex gap-5 bg-background-100 rounded-lg p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-24 h-32 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={`${manga.title} - 成人漫画推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded">
                    {manga.category}
                  </span>
                  <span className="text-xs text-foreground-400">{manga.chapters}话</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {manga.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                  {manga.description.slice(0, 80)}...
                </p>
                <div className="flex items-center gap-1 mt-3">
                  {manga.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}